import React from 'react';
import { Typography, Box, Link } from '@mui/material';

const Footer = () => {
  return (
    <Box
      component='footer'
      sx={{
        py: 3,
        px: 2,
        mt: 'auto',
        backgroundColor: (theme) => theme.palette.grey[200],
        textAlign: 'center',
      }}
      className='bg-indigo-100'
    >
      <Typography variant='body2' color='text.secondary'>
        © {new Date().getFullYear()}{' '}
        <Link
          href='https://staticval.com'
          target='_blank'
          rel='noreferrer'
          className='text-blue-600 ml-1'
          underline='hover'
          sx={{ fontSize: 'inherit' }}
        >
          staticval.com
        </Link>
        . All rights reserved.
      </Typography>
    </Box>
  );
};
export default Footer;
